module.exports = __webpack_public_path__ + "img/guria-en-us.f7074986.png";